"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("styled-components").css`
    &.CTAPlannerCard {
        background-color: ${({backgroundColor:e})=>e||"#0075C9"};
        background-repeat: no-repeat;
        background-position: left;
        display: flex;
        align-items: center;
        position: relative;
        border-radius: 5px;
        overflow: hidden;

        .CTAPlannerCard-accent {
            width: ${({secondaryComponent:e})=>e?"30%":"unset"};
            max-height: ${({secondaryComponent:e})=>!e&&"200px"};

            img {
                object-fit: contain;
                width: ${({secondaryComponent:e})=>!e&&"unset"};
                position: unset;
                height: 100%;
                max-height: ${({secondaryComponent:e})=>!e&&"200px"};
            }
            .aspect-ratio {
                display: none;
            }
        }

        .CTAPlannerCard-content {
            z-index: 1;
            padding: 60px 40px;
            display: flex;
            flex-wrap: nowrap;
            flex-direction: ${({contentFlexDirection:e})=>e||"row"};
            align-items: ${({contentAlignment:e})=>e||"center"};
            justify-content: space-between;
            width: 100%;

            .CTAPlannerCard-textContainer {
                padding: ${({theme:e})=>e.spacing.large} 0;
                width: ${({secondaryComponent:e,foregroundImg:n})=>n&&!e&&"50%"};

                .CTAPlannerCard-chip {
                    margin: 0 0 8px 0;
                }

                .CTAPlannerCard-heading {
                    color: ${({theme:e})=>e.colors.common.light};
                    font-weight: 300;
                    line-height: 36px;
                }

                .CTAPlannerCard-description {
                    color: ${({theme:e})=>e.colors.secondary.light};
                    line-height: 24px;
                }
            }

            .CTAPlannerCard-clickContainer {
                margin-top: ${({theme:e,contentFlexDirection:n})=>"column"===n?e.spacing.large:"0"};

                .CTAPlannerCard-btn {
                    .DXTypography {
                        color: ${({theme:e})=>e.colors.common.light};
                        white-space: nowrap;
                        line-height: unset;
                        margin: 0;
                    }
                }

                .CTAPlannerCard-link {
                    transform: rotate(180deg);
                    height: 50px;
                    width: 50px;
                    background: white;
                    border-radius: 50%;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    svg {
                        height: 35%;
                        width: 35%;
                        path {
                            color: ${({theme:e})=>e.colors.primary.default};
                        }
                    }
                }
            }
        }

        .CTAPlannerCard-secondary {
            margin: ${({theme:e})=>e.spacing.medium};
            padding: ${({theme:e})=>e.spacing.xlarge};
            margin-bottom: 10%;
            z-index: 1;
            background: ${({theme:e})=>e.colors.secondary.light};
            z-index: 1;
            border-radius: 5px;
            text-align: center;
            display: inline-flex;
            align-self: stretch;
            width: 100%;
        }

        .CTAPlannerCard-background {
            position: absolute;
            top: 0;
            right: 0;
            max-width: 40%;
            max-height: 70%;
            object-fit: contain;
        }

        .CTAPlannerCard-foreground {
            position: absolute;
            right: 0;
            bottom: 0;
            z-index: ${({foregroundStyles:e})=>(null==e?void 0:e.zIndex)?e.zIndex:1};
            max-height: ${({foregroundStyles:e})=>(null==e?void 0:e.maxHeight)?e.maxHeight:"45%"};
            max-width: ${({foregroundStyles:e})=>(null==e?void 0:e.maxWidth)?e.maxWidth:"35%"};
            pointer-events: none;

            img {
                position: absolute;
                right: 0;
                bottom: 0;
                top: unset;
                left: unset;
                height: 100%;
            }
        }

        @media (max-width: ${({theme:e})=>e.breakpoints.medium}) {
            width: 360px;
            margin: auto;
            flex-wrap: wrap;

            .CTAPlannerCard-accent {
                position: absolute;
                bottom: 10%;
                top: ${({secondaryComponent:e})=>!!e&&"5%"};
                right: ${({secondaryComponent:e})=>!!e&&"-15px"};
                transform: ${({secondaryComponent:e})=>!!e&&"rotate(180deg)"};
                max-height: 140px;
                display: ${({secondaryComponent:e})=>!e&&"none"};

                img {
                    transform: ${({secondaryComponent:e})=>!e&&"translateY(45%)"};
                }
            }

            .CTAPlannerCard-content {
                flex-wrap: wrap;
                z-index: 1;
                padding: ${({secondaryComponent:e})=>e?"30px 20px 0px":"30px 20px 50px"};

                .CTAPlannerCard-textContainer {
                    padding-bottom: ${({secondaryComponent:e})=>e?"0px":"5rem"};
                    width: ${({secondaryComponent:e})=>!e&&"100%"};

                    .DXChip {
                        font-size: 12px;
                    }

                    .CTAPlannerCard-heading {
                        width: ${({secondaryComponent:e})=>e?"70%":"100%"};
                        font-size: 22px;
                        margin: unset;
                    }

                    .CTAPlannerCard-description {
                        width: ${({secondaryComponent:e})=>e?"85%":"100%"};
                    }
                }
            }

            .CTAPlannerCard-background {
                display: none;
            }

            .CTAPlannerCard-foreground {
                display: ${({secondaryComponent:e})=>!!e&&"none"};
            }
        }
    }
`;exports.default=e,exports.styles=e;
//# sourceMappingURL=styles.js.map
